import cn from 'classnames'
import capitalize from 'lodash/capitalize'
import Banner from '@mc/banner'
import { useFreeTrial } from '@mc/free-trial'
import { useTranslation } from '@mc/i18n'
import Image from 'components/LegacyImage'

const GuestPassBanner = () => {
  const { t } = useTranslation('@mc/next')
  const { trial } = useFreeTrial()

  if (trial.isPartnershipTrial || !trial.advocate) return <></>

  const advocateName = capitalize(trial.advocate.name)

  return (
    <Banner
      className='mc-bg-gray-200 mc-py-4'
      aria-label={t('guestPass.header.a11y.bannerAriaLabel')}
    >
      {trial.advocate.profileImg && (
        <Image
          alt=''
          className='mc-corners--circle'
          height={32}
          src={trial.advocate.profileImg}
          width={32}
        />
      )}
      <div className='d-none d-md-block'>
        <p className='mc-text-h7 mc-ml-4'>
          {t('guestPass.header.advocateName', {
            name: advocateName,
          })}
        </p>
      </div>
      <div className='d-block d-md-none'>
        <p
          className={cn('d-flex mc-text-h7 mc-ml-2', {
            'flex-md-column': trial.advocate.hasLargeName,
            'mc-text--center':
              trial.advocate.hasLargeName && !trial.advocate.profileImg,
          })}
        >
          {t('guestPass.header.advocateName', {
            name: advocateName,
          })}
        </p>
      </div>
    </Banner>
  )
}

export default GuestPassBanner
